import type { SystemRole } from '@/hooks/useAcl';

export interface UserProfile {
  name: string;
  email: string;
  phone: string;
}

export const userProfiles: Record<string, UserProfile> = {
  'Super Admin':  { name: 'Aarav Mehta',      email: 'aarav.mehta@thriveability.org.au',    phone: '+61 400 111 222' },
  'Admin':        { name: 'Sarah Mitchell',    email: 'sarah.mitchell@thriveability.org.au', phone: '+61 400 333 444' },
  'Coordinator':  { name: 'Michael Torres',    email: 'michael.torres@thriveability.org.au', phone: '+61 400 555 666' },
  'Teacher':      { name: 'Emily Chen',        email: 'emily.chen@thriveability.org.au',     phone: '+61 400 777 888' },
  'Therapist':    { name: 'Dr. James Carter',  email: 'james.carter@thriveability.org.au',   phone: '+61 400 999 000' },
  'Parent':       { name: 'Lisa Wang',         email: 'lisa.wang@email.com',                 phone: '+61 411 222 333' },
  'Student':      { name: 'Oliver Davis',      email: 'oliver.davis@email.com',              phone: '+61 422 333 444' },
  'Accountant':   { name: 'Priya Sharma',      email: 'priya.sharma@thriveability.org.au',   phone: '+61 400 444 555' },
  'Librarian':    { name: 'Daniel Kim',        email: 'daniel.kim@thriveability.org.au',     phone: '+61 400 666 777' },
  'Receptionist': { name: 'Chloe Wilson',      email: 'chloe.wilson@thriveability.org.au',   phone: '+61 400 888 999' },
};

export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((part) => part.replace(/^Dr\./, '').trim().charAt(0).toUpperCase())
    .filter(Boolean)
    .slice(0, 2)
    .join('');
}